import { takeLatest, all, put } from "redux-saga/effects";
import * as calls from "./calls";
import * as reducerActions from "../../reducers/ContenidoReducer/actions";
import * as Notifications from "../../components/Common/notification";

import * as layoutActions from "../../reducers/layoutReducer/actions";

function* genGetTiposContenido() {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Obteniendo tipos de contenido" }));
    // llamo a la acción que trae los contenido
    let tiposContenido = yield calls.getTiposContenido();

    yield put(reducerActions.setTiposContenido(tiposContenido));
  } catch (error) {
    if (error.Message) {
      return;
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genGetContenidos(e) {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Obteniendo contenidos" }));
    // llamo a la acción que trae los contenido
    let contenidos = yield calls.getContenido(e.payload);

    yield put(reducerActions.setContenido(contenidos));
  } catch (error) {
    if (error.Message) {
      return;
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genGetContenidoById(e) {
  try {
    yield put(
      layoutActions.setLoading({ show: true, message: "Obteniendo contenido seleccionado" })
    );
    // llamo a la acción que trae los contenido
    let contenido = yield calls.getContenidoById(e.payload);

    yield put(reducerActions.setContenidoById(contenido));
  } catch (error) {
    if (error.Message) {
      return;
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

// Editar contenido
function* genPutContenidos(e) {
  try {
    let callback = e.payload.callback;
    e.payload.callback = undefined;
    yield put(layoutActions.setLoading({ show: true, message: "Guardando contenido editado" }));
    // llamo a la acción que trae los contenido
    yield calls.putContenido(e.payload);

    if (callback !== undefined) {
      callback();
    }

    Notifications.showSuccess("Contenido guardado con éxito");
  } catch (error) {
    if (error.Message) {
      return;
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genBorrarContenido(e) {
  try {
    yield put(layoutActions.setLoading({ show: true, message: "Borrando contenido" }));
    // llamo a la acción que trae los contenido
    yield calls.borrarContenido(e.payload);

    yield put(reducerActions.setContenidoInactivo(e.payload));

    Notifications.showSuccess("Contenido eliminado");
  } catch (error) {
    if (error.Message) {
      return;
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genSaveContenido(e) {
  try {
    let callback = e.payload.callback;
    e.payload.callback = undefined;
    yield put(layoutActions.setLoading({ show: true, message: "Guardando contenido" }));
    // llamo a la acción que trae los contenido
    yield calls.saveContenido(e.payload);

    if (callback !== undefined) {
      callback();
    }

    Notifications.showSuccess("Contenido guardado con éxito");
  } catch (error) {
    if (error.Message) {
      return;
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genSwapContenido(e) {
  try {
    //yield put(layoutActions.setLoading({ show: true, message: 'Cambiando orden de contenidos' }))
    // llamo a la acción que trae los contenidos
    let contenidos = yield calls.swapContenido(e.payload);

    yield put(reducerActions.setContenido(contenidos));

    Notifications.showSuccess("Contenido desplazado ");
  } catch (error) {
    if (error.Message) {
      return;
    }
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* defaultSaga() {
  yield all([
    takeLatest(reducerActions.SAGA_GET_TIPOS_CONTENIDO, genGetTiposContenido),
    takeLatest(reducerActions.SAGA_GET_CONTENIDOS, genGetContenidos),
    takeLatest(reducerActions.SAGA_PUT_CONTENIDOS, genPutContenidos),
    takeLatest(reducerActions.SAGA_BORRAR_CONTENIDO, genBorrarContenido),
    takeLatest(reducerActions.SAGA_SAVE_CONTENIDO, genSaveContenido),
    takeLatest(reducerActions.SAGA_SWAP_CONTENIDO, genSwapContenido),
    takeLatest(reducerActions.SAGA_GET_CONTENIDOSBYID, genGetContenidoById),
  ]);
}

export const sagas = [defaultSaga];
